import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import { DataGrid,GridToolbar,GridCellModes  } from '@mui/x-data-grid';
import { Pagination } from "@mui/material";
import Box from '@mui/material/Box';
import { Row, Col, Table,  Form, Modal, Dropdown, } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import Card from "../../../../../components/Card";
import CustomToggle from "../../../../../components/dropdowns";
import Button from '@mui/material/Button';
import Select from 'react-select';
import config from "../../../../../config/config";
import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import "../../../../App.css";
import { width } from '@mui/system';
import swal from 'sweetalert';
import { darken, lighten, styled } from '@mui/material/styles';
import {jsPDF} from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import Spinner from 'react-bootstrap/Spinner';

const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const getSelectedBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

const getSelectedHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .super-app-theme--Open': {
    backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.info.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Filled': {
    backgroundColor: getBackgroundColor(
      theme.palette.success.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.success.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--PartiallyFilled': {
    backgroundColor: getBackgroundColor(
      theme.palette.warning.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.warning.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Rejected': {
    backgroundColor: getBackgroundColor(
      theme.palette.error.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.error.main,
          theme.palette.mode,
        ),
      },
    },
  },
}));


const TableData = (props) => {
	console.log('testing page')
	
  const today = new Date();
  const numberOfDaysToAdd = 0;
  const date = today.setDate(today.getDate() + numberOfDaysToAdd); 
  const defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
  var Finyear=sessionStorage.getItem("FinYear");
  Finyear=Finyear.substring(0,4);

  const reportOptions = [
    { value: '1', label: 'Ornament Report All' },
    { value: '2', label: 'BO OJ Report' },
    { value: '3', label: 'Touch Difference Report' }
  ]


	useEffect(() => {
    setpage(1);
    setuserId(0);
    setacmaster(0);
    getLookup();
 ;

    //  document.getElementById("txtFromDate").value=(new Date()).toISOString().substring(0,10);
    //  document.getElementById("txtTodate").value=(new Date()).toISOString().substring(0,10);

  }, []);

const listPg = (event, value) => {
    setpage(value);
    setuserId(0);
    getLookup();
   
   
  };

  const navigate = useNavigate();
  const ActionAdd = () => {
	  sessionStorage.setItem("UserManagement_Action", "Add");
	  sessionStorage.setItem("UserManagement_EditId", "0");
    navigate('../dashboard/table/admin/usermanagement/entry');
  };


  const ActionEdit = (menuName,groupId,selectGroupId,Department) => {
	  
	sessionStorage.setItem("UserManagement_Action", "Edit");
    //sessionStorage.setItem("UserManagement_EditId", editid);
    sessionStorage.setItem("UserManagement_GroupId", groupId);
    sessionStorage.setItem("UserManagement_MenuName", menuName);
    sessionStorage.setItem("UserManagement_selectGroupId", selectGroupId);
    sessionStorage.setItem("UserManagement_Department", Department);
    navigate('../dashboard/table/admin/usermanagement/entry');
  };

const ActionDelete = (editid) => {
	  
	sessionStorage.setItem("UserManagement_Action", "Delete");
    sessionStorage.setItem("UserManagement_EditId", editid);
    navigate('../dashboard/table/admin/usermanagement/entry');
  };

  const [DtUserGroup, setUserGroup]=useState([]);
  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [GroupId, setGroupId, GroupIdRef] = useStateRef();
  const [reportName, setReportName, ReportNameRef] = useStateRef();
  const [userId, setuserId, userIdRef] = useStateRef('0');
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [page, setpage, pageRef] = useStateRef('1');
  const [acmaster, setacmaster, acmasterRef] = useStateRef('0');
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();
  const [GridData, setGridData] = useState([]);
  const handleClose1 = () => setShow1(false);
  const [isDisabled, setisDisabled]=useState(false);
  const [Search, setSearch, SearchRef] = useStateRef('');
  
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [editRowsModel, setEditRowsModel] = React.useState({});
  const [loading, setLoading] = React.useState(false)
  const [btndisabled, setDisabled] = useState('disabled');
  const [newDataRows, setRows] = React.useState([]);
  const [srcURL, setsrcURL] = useState("");
  var dataRows=[];
 
  
  // useEffect(() => {
    
  // }, [newDataRows]);

  async function getLookup(){
    try {
      setGroupId('1');
     let postData=[];
 
 
     const results = await apiService.postCall("metalreceipt/Lookup",postData);
  
    if (results != "-1") {
 
      setUserGroup(results.data[0][0]);

       }
  
     } catch (error) {
       console.log(error);
     }
 }
 const BackToList = () => {
  setDisabled('disabled');
 
};

const addFooters = doc => {
  const pageCount = doc.internal.getNumberOfPages()
  const todayDate = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
  const printOn=moment(todayDate).format("DD-MM-YYYY");
  doc.setFont('times', 'normal')
  doc.setFontSize(8)
  for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
    
      let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; //Current Page
      doc.text('Page: ' + pageCurrent + ' of ' + pageCount, 200, 10, 'right');
      doc.text('Printed on : ' + printOn, 200, doc.internal.pageSize.height - 10, 'right');
  
  }
}

async function tochDiffReport(){
  try
  {
    var pdfDoc = new jsPDF('a4');
    var pdfYpos=10;
    pdfDoc.text("Avathar Jewells", 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
    pdfDoc.setFontSize(10);
    pdfDoc.setFont("Times", "bold");
    var fdate=moment(document.getElementById("txtFromDate").value).format("DD-MM-YYYY");
    var tdate= moment(document.getElementById("txtToDate").value).format("DD-MM-YYYY");
    pdfDoc.text("Touch Difference Report From "+fdate +" To "+ tdate, 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
      
    var headData = [];
    var tempBody = [];
var bodyHeight=0;
    headData.push({
      lotNo: "LOT NO",
      lotDate: "LOT DATE",
      product: "PRODUCT",
      subproduct: "SUB PRODUCT",
      grosswt: "GROSS WT",
      fixTch: "FIX TCH",
      lotTch: "LOT TCH",
      difTch: "DIF TCH",
    })

    debugger;
    for (var i=0;i<=dataRows.length-1;i++){
      var lotDate=moment(dataRows[i].lotDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
        lotDate="";
      }
      debugger;
          tempBody.push({
            lotNo:dataRows[i].lotNo,
            lotDate: lotDate,
            product:dataRows[i].product,
            subproduct:dataRows[i].subProduct,
            grosswt: parseFloat(dataRows[i].grossWt).toFixed(2),
            fixTch: parseFloat(dataRows[i].fixTch).toFixed(2),
            lotTch: parseFloat(dataRows[i].lotTch).toFixed(2),
            difTch: parseFloat(dataRows[i].diffTch).toFixed(2),
          })
}

        autoTable(pdfDoc, {
          startY: pdfYpos,
          head: headData,
          body: tempBody,
          tableWidth: 200,
          margin: {
            top: 20,
            bottom: 20,
            left: 10,
            right: 10,
            width: 200
        },
        willDrawCell: function (data) {
          if (data.row.section === 'body') {
              var height = (data.table.body.length + 1) * data.table.body[0].height;
              bodyHeight = height;
          }
         
        },
        styles: {
          overflow: 'linebreak', cellwidth: 'auto'
        },
        headStyles: {
            fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
        },
        theme: "grid",
        bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

        columnStyles: {
            0: { halign: "left", cellWidth: 20 }, 
            1: { halign: "left", cellWidth: 20 },
            2: { halign: "left", cellWidth: 40 },
            3: { halign: "left", cellWidth: 40 },
            4: { halign: "right", cellWidth: 20 },
            5: { halign: "right", cellWidth: 15 },
            6: { halign: "right", cellWidth: 20 },
            7: { halign: "right", cellWidth: 15 },
            },
        })

        addFooters(pdfDoc);
        setsrcURL(pdfDoc.output('datauristring'));
        setShow1(true);

  }
  catch (error) {
    console.log(error);
  }
}

async function BOOldGoldWt(){
  try
  {
    var pdfDoc = new jsPDF('a4');
    var pdfYpos=10;
    pdfDoc.text("Avathar Jewells", 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
    pdfDoc.setFontSize(10);
    pdfDoc.setFont("Times", "bold");
    var fdate=moment(document.getElementById("txtFromDate").value).format("DD-MM-YYYY");
    var tdate= moment(document.getElementById("txtToDate").value).format("DD-MM-YYYY");
    pdfDoc.text("OJ Report From "+fdate +" To "+ tdate, 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
      
    var headData = [];
    var tempBody = [];
var bodyHeight=0;
    headData.push({
      date: "DATE",
      total: "TOTAL",
      ajoj: "AJ OJ",
      oj: "OJ",
      sign: "SIGN",
    })

    debugger;
    for (var i=0;i<=dataRows.length-1;i++){
      var lotDate=moment(dataRows[i].sDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
        lotDate="";
      }
      debugger;
          tempBody.push({
            date: lotDate,
            total: parseFloat(dataRows[i].totalWt).toFixed(2),
            ajoj: parseFloat(dataRows[i].ajOJWt).toFixed(2),
            oj: parseFloat(dataRows[i].OJWt).toFixed(2),
            sign: '',
          })
}

        autoTable(pdfDoc, {
          startY: pdfYpos,
          head: headData,
          body: tempBody,
          tableWidth: 200,
          margin: {
            top: 20,
            bottom: 20,
            left: 10,
            right: 10,
            width: 200
        },
        willDrawCell: function (data) {
          if (data.row.section === 'body') {
              var height = (data.table.body.length + 1) * data.table.body[0].height;
              bodyHeight = height;
          }
         
        },
        styles: {
          overflow: 'linebreak', cellwidth: 'auto'
        },
        headStyles: {
            fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
        },
        theme: "grid",
        bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

        columnStyles: {
            0: { halign: "left", cellWidth: 25 }, //Employee name 
            1: { halign: "right", cellWidth: 25 },//Hrs
            2: { halign: "right", cellWidth: 25 },//Rate
            3: { halign: "right", cellWidth: 25 },//Rate
            4: { halign: "right", cellWidth: 50 },//Rate
            },
        })

        addFooters(pdfDoc);
        setsrcURL(pdfDoc.output('datauristring'));
        setShow1(true);

  }
  catch (error) {
    console.log(error);
  }
}

async function OrnamentReportAll(){

  try
  {
  
   
    var pdfDoc = new jsPDF('a4');
    var pdfYpos=10;
    pdfDoc.text("Avathar Jewells", 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
    pdfDoc.setFontSize(10);
    pdfDoc.setFont("Times", "bold");
    var fdate=moment(document.getElementById("txtFromDate").value).format("DD-MM-YYYY");
    var tdate= moment(document.getElementById("txtToDate").value).format("DD-MM-YYYY");
    pdfDoc.text("Ornament Report All "+fdate +" To "+ tdate, 100, pdfYpos, 'center');
    
    pdfYpos=pdfYpos+10;
      
    var headData = [];
    var tempBody = [];


    headData.push({
     LotNo: "Lot No ",
     LotDate: "Lot Date",
     AccDesc: "Dealer Name",
     Opening: "Opening",
     Receipt: "Receipt",
     Issue: "Issue",
     Closing: "Closing",
   })
   var bodyheightTwo=0;
   var bodyHeight=0;
  
/* GOLD ORNAMENTS */
var goldOrns= dataRows.filter(function (el) {
    return el.Remark == 'GOLD ORNAMENTS';
  });
    
   var totalgoldOrns = [...goldOrns.reduce((r, o) => {
           const key = o.Remark.toString() ;

           const item = r.get(key) || Object.assign({}, o, {
            OpenWt: 0,
            RecWt: 0,
            HoTagWt: 0,
            BalanceWt: 0
           });

           item.OpenWt += o.OpenWt;
           item.RecWt += o.RecWt;
           item.HoTagWt += o.HoTagWt;
           item.BalanceWt += o.BalanceWt;

           return r.set(key, item);
    }, new Map).values()];

      
    if (totalgoldOrns.length>0){
        tempBody.push({
          LotNo: '',
          LotDate: '',
          AccDesc: 'GOLD ORNAMENTS',
          Opening: totalgoldOrns[0].OpenWt,
          Receipt: totalgoldOrns[0].RecWt,
          Issue: totalgoldOrns[0].HoTagWt,
          Closing: totalgoldOrns[0].BalanceWt,
          Bold:"BoldFont",
        })
  }

   for (var i=0;i<=goldOrns.length-1;i++){
    
            var lotDate=moment(goldOrns[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
            if (lotDate=="01-01-1900"){
              lotDate="";
            }
                tempBody.push({
                  LotNo: goldOrns[i].LotNo,
                  LotDate: lotDate,
                  AccDesc: goldOrns[i].AccDesc,
                  Opening: goldOrns[i].OpenWt,
                  Receipt: goldOrns[i].RecWt,
                  Issue: goldOrns[i].HoTagWt,
                  Closing: goldOrns[i].BalanceWt,
                  Bold:"",
                })
  
  }
  
    autoTable(pdfDoc, {
      startY: pdfYpos,
      head: headData,
      body: tempBody,
      tableWidth: 200,
      margin: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
        width: 200
    },
    willDrawCell: function (data) {
      if (data.row.section === 'body') {
          var height = (data.table.body.length + 1) * data.table.body[0].height;
          bodyHeight = height;
      }
      if (data.row.index == 0) {
      if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {

        if (data.cell.raw == "GOLD ORNAMENTS") {
          pdfDoc.setFontSize(9);
          pdfDoc.setTextColor(128, 0, 0);
          pdfDoc.setFont("Times", "bold");
        }
        else
        {
          pdfDoc.setFontSize(9);
          pdfDoc.setFont("Times", "bold");
        }
      }

    }
  },
    styles: {
      overflow: 'linebreak', cellwidth: 'auto'
    },
    headStyles: {
        fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
    },
    theme: "grid",
    bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

    columnStyles: {
        0: { halign: "left", cellWidth: 25 }, //Employee name 
        1: { halign: "left", cellWidth: 25 },//Hrs
        2: { halign: "left", cellWidth: 45 },//Rate
        3: { halign: "right", cellWidth: 25 },//Rate
        4: { halign: "right", cellWidth: 25 },//Rate
        5: { halign: "right", cellWidth: 25 },//Rate
        6: { halign: "right", cellWidth: 25 },//Rate
        },
    })

  if (pdfYpos >= 250) {
        pdfYpos = 20;
        pdfDoc.addPage('p');
    }

    /* SILVER ORNAMENTS */
    tempBody=[];
    var SilOrns= dataRows.filter(function (el) {
      return el.Remark == 'SILVER ORNAMENTS';
    });
  
 var totalSilOrns = [...SilOrns.reduce((r, o) => {
         const key = o.Remark.toString() ;

         const item = r.get(key) || Object.assign({}, o, {
          OpenWt: 0,
          RecWt: 0,
          HoTagWt: 0,
          BalanceWt: 0
         });

         item.OpenWt += o.OpenWt;
         item.RecWt += o.RecWt;
         item.HoTagWt += o.HoTagWt;
         item.BalanceWt += o.BalanceWt;

         return r.set(key, item);
  }, new Map).values()];

    
  if(totalSilOrns.length>0){
      tempBody.push({
        LotNo: '',
        LotDate: '',
        AccDesc: 'SILVER ORNAMENTS',
        Opening: totalSilOrns[0].OpenWt,
        Receipt: totalSilOrns[0].RecWt,
        Issue: totalSilOrns[0].HoTagWt,
        Closing: totalSilOrns[0].BalanceWt,
      })
  }
    


 for (var i=0;i<=SilOrns.length-1;i++){
  
      var lotDate=moment(SilOrns[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
      lotDate="";
      }
        tempBody.push({
          LotNo: SilOrns[i].LotNo,
          LotDate: lotDate,
          AccDesc: SilOrns[i].AccDesc,
          Opening: SilOrns[i].OpenWt,
          Receipt: SilOrns[i].RecWt,
          Issue: SilOrns[i].HoTagWt,
          Closing: SilOrns[i].BalanceWt,
        })

}

if (tempBody.length>0){
  pdfYpos=pdfYpos+bodyHeight;
}


  autoTable(pdfDoc, {
    startY: pdfYpos,
    head: [],
    body: tempBody,
    tableWidth: 200,
    margin: {
      top: 20,
      bottom: 20,
      left: 10,
      right: 10,
      width: 200
  },
  willDrawCell: function (data) {
    if (data.row.section === 'body') {
        var height = (data.table.body.length + 1) * data.table.body[0].height;
        bodyHeight = height;
    }
    if (data.row.index == 0) {
    if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {

      if (data.cell.raw == "SILVER ORNAMENTS") {
        pdfDoc.setFontSize(9);
        pdfDoc.setTextColor(128, 0, 0);
        pdfDoc.setFont("Times", "bold");
      }
      else
      {
        pdfDoc.setFontSize(9);
        pdfDoc.setFont("Times", "bold");
      }
    }

  }
},
  styles: {
    overflow: 'linebreak', cellwidth: 'auto'
  },
  headStyles: {
      fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
  },
  theme: "grid",
  bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

  columnStyles: {
      0: { halign: "left", cellWidth: 25 }, //Employee name 
      1: { halign: "left", cellWidth: 25 },//Hrs
      2: { halign: "left", cellWidth: 45 },//Rate
      3: { halign: "right", cellWidth: 25 },//Rate
      4: { halign: "right", cellWidth: 25 },//Rate
      5: { halign: "right", cellWidth: 25 },//Rate
      6: { halign: "right", cellWidth: 25 },//Rate
      },
  })


    /* GOLD BAR */
    tempBody=[];
    var goldBar= dataRows.filter(function (el) {
      return el.Remark == 'GOLD BAR';
    });
 var totalGoldBar = [...goldBar.reduce((r, o) => {
         const key = o.Remark.toString() ;

         const item = r.get(key) || Object.assign({}, o, {
          OpenWt: 0,
          RecWt: 0,
          HoTagWt: 0,
          BalanceWt: 0
         });

         item.OpenWt += o.OpenWt;
         item.RecWt += o.RecWt;
         item.HoTagWt += o.HoTagWt;
         item.BalanceWt += o.BalanceWt;

         return r.set(key, item);
  }, new Map).values()];

    
  if(totalGoldBar.length>0){
      tempBody.push({
        LotNo: '',
        LotDate: '',
        AccDesc: 'GOLD BAR',
        Opening: totalGoldBar[0].OpenWt,
        Receipt: totalGoldBar[0].RecWt,
        Issue: totalGoldBar[0].HoTagWt,
        Closing: totalGoldBar[0].BalanceWt,
      })
  }
    


 for (var i=0;i<=goldBar.length-1;i++){
  
      var lotDate=moment(goldBar[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
      lotDate="";
      }
        tempBody.push({
          LotNo: goldBar[i].LotNo,
          LotDate: lotDate,
          AccDesc: goldBar[i].AccDesc,
          Opening: goldBar[i].OpenWt,
          Receipt: goldBar[i].RecWt,
          Issue: goldBar[i].HoTagWt,
          Closing: goldBar[i].BalanceWt,
        })

}

if (tempBody.length>0){
  pdfYpos=pdfYpos+bodyHeight;
}
if (pdfYpos >= 250) {
  pdfYpos = 20;
  pdfDoc.addPage('p');
}
  autoTable(pdfDoc, {
    startY: pdfYpos,
    head: [],
    body: tempBody,
    tableWidth: 200,
    margin: {
      top: 20,
      bottom: 20,
      left: 10,
      right: 10,
      width: 200
  },
  willDrawCell: function (data) {
    if (data.row.section === 'body') {
        var height = (data.table.body.length) * data.table.body[0].height;
        bodyHeight = height;
    }
    if (data.row.index == 0) {
    if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {

      if (data.cell.raw == "GOLD BAR") {
        pdfDoc.setFontSize(9);
        pdfDoc.setTextColor(128, 0, 0);
        pdfDoc.setFont("Times", "bold");
      }
      else
      {
        pdfDoc.setFontSize(9);
        pdfDoc.setFont("Times", "bold");
      }
    }

  }
},
  styles: {
    overflow: 'linebreak', cellwidth: 'auto'
  },
  headStyles: {
      fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
  },
  theme: "grid",
  bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

  columnStyles: {
      0: { halign: "left", cellWidth: 25 }, //Employee name 
      1: { halign: "left", cellWidth: 25 },//Hrs
      2: { halign: "left", cellWidth: 45 },//Rate
      3: { halign: "right", cellWidth: 25 },//Rate
      4: { halign: "right", cellWidth: 25 },//Rate
      5: { halign: "right", cellWidth: 25 },//Rate
      6: { halign: "right", cellWidth: 25 },//Rate
      },
  })


   /* SILVER BAR */

   tempBody=[];
   var silverBar= dataRows.filter(function (el) {
     return el.Remark == 'SILVER BAR';
   });

   
var totalSilverBar = [...silverBar.reduce((r, o) => {
        const key = o.Remark.toString() ;

        const item = r.get(key) || Object.assign({}, o, {
         OpenWt: 0,
         RecWt: 0,
         HoTagWt: 0,
         BalanceWt: 0
        });

        item.OpenWt += o.OpenWt;
        item.RecWt += o.RecWt;
        item.HoTagWt += o.HoTagWt;
        item.BalanceWt += o.BalanceWt;

        return r.set(key, item);
 }, new Map).values()];

   
 if(totalSilverBar.length>0){
     tempBody.push({
       LotNo: '',
       LotDate: '',
       AccDesc: 'SILVER BAR',
       Opening: totalSilverBar[0].OpenWt,
       Receipt: totalSilverBar[0].RecWt,
       Issue: totalSilverBar[0].HoTagWt,
       Closing: totalSilverBar[0].BalanceWt,
     })
 }
   


for (var i=0;i<=silverBar.length-1;i++){
 
     var lotDate=moment(silverBar[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
     if (lotDate=="01-01-1900"){
     lotDate="";
     }
       tempBody.push({
         LotNo: silverBar[i].LotNo,
         LotDate: lotDate,
         AccDesc: silverBar[i].AccDesc,
         Opening: silverBar[i].OpenWt,
         Receipt: silverBar[i].RecWt,
         Issue: silverBar[i].HoTagWt,
         Closing: silverBar[i].BalanceWt,
       })

}

if (tempBody.length>0){
 pdfYpos=pdfYpos+bodyHeight;
}
if (pdfYpos >= 250) {
  pdfYpos = 20;
  pdfDoc.addPage('p');
}

 autoTable(pdfDoc, {
   startY: pdfYpos,
   head: [],
   body: tempBody,
   tableWidth: 200,
   margin: {
     top: 20,
     bottom: 20,
     left: 10,
     right: 10,
     width: 200
 },
 willDrawCell: function (data) {
   if (data.row.section === 'body') {
       var height = (data.table.body.length) * data.table.body[0].height;
       bodyHeight = height;
   }
   if (data.row.index == 0) {
   if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {

     if (data.cell.raw == "SILVER BAR") {
       pdfDoc.setFontSize(9);
       pdfDoc.setTextColor(128, 0, 0);
       pdfDoc.setFont("Times", "bold");
     }
     else
     {
       pdfDoc.setFontSize(9);
       pdfDoc.setFont("Times", "bold");
     }
   }

 }
},
 styles: {
   overflow: 'linebreak', cellwidth: 'auto'
 },
 headStyles: {
     fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
 },
 theme: "grid",
 bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

 columnStyles: {
     0: { halign: "left", cellWidth: 25 }, //Employee name 
     1: { halign: "left", cellWidth: 25 },//Hrs
     2: { halign: "left", cellWidth: 45 },//Rate
     3: { halign: "right", cellWidth: 25 },//Rate
     4: { halign: "right", cellWidth: 25 },//Rate
     5: { halign: "right", cellWidth: 25 },//Rate
     6: { halign: "right", cellWidth: 25 },//Rate
     },
 })


    /* KATCHA */

    tempBody=[];
    var katcha= dataRows.filter(function (el) {
      return el.Remark == 'KATCHA';
    });
 var totalKatcha = [...katcha.reduce((r, o) => {
         const key = o.Remark.toString() ;
 
         const item = r.get(key) || Object.assign({}, o, {
          OpenWt: 0,
          RecWt: 0,
          HoTagWt: 0,
          BalanceWt: 0
         });
 
         item.OpenWt += o.OpenWt;
         item.RecWt += o.RecWt;
         item.HoTagWt += o.HoTagWt;
         item.BalanceWt += o.BalanceWt;
 
         return r.set(key, item);
  }, new Map).values()];
 
    
  if(totalKatcha.length>0){
      tempBody.push({
        LotNo: '',
        LotDate: '',
        AccDesc: 'KATCHA',
        Opening: totalKatcha[0].OpenWt,
        Receipt: totalKatcha[0].RecWt,
        Issue: totalKatcha[0].HoTagWt,
        Closing: totalKatcha[0].BalanceWt,
      })
  }
    
 
 
 for (var i=0;i<=katcha.length-1;i++){
  
      var lotDate=moment(katcha[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
      lotDate="";
      }
        tempBody.push({
          LotNo: katcha[i].LotNo,
          LotDate: lotDate,
          AccDesc: katcha[i].AccDesc,
          Opening: katcha[i].OpenWt,
          Receipt: katcha[i].RecWt,
          Issue: katcha[i].HoTagWt,
          Closing: katcha[i].BalanceWt,
        })
 
 }
 
 if (tempBody.length>0){
  pdfYpos=pdfYpos+bodyHeight;
 }
 
 if (pdfYpos >= 250) {
  pdfYpos = 20;
  pdfDoc.addPage('p');
}
 
  autoTable(pdfDoc, {
    startY: pdfYpos,
    head: [],
    body: tempBody,
    tableWidth: 200,
    margin: {
      top: 20,
      bottom: 20,
      left: 10,
      right: 10,
      width: 200
  },
  willDrawCell: function (data) {
    if (data.row.section === 'body') {
        var height = (data.table.body.length) * data.table.body[0].height;
        bodyHeight = height;
    }
    if (data.row.index == 0) {
    if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
 
      if (data.cell.raw == "KATCHA") {
        pdfDoc.setFontSize(9);
        pdfDoc.setTextColor(128, 0, 0);
        pdfDoc.setFont("Times", "bold");
      }
      else
      {
        pdfDoc.setFontSize(9);
        pdfDoc.setFont("Times", "bold");
      }
    }
 
  }
 },
  styles: {
    overflow: 'linebreak', cellwidth: 'auto'
  },
  headStyles: {
      fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
  },
  theme: "grid",
  bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
 
  columnStyles: {
      0: { halign: "left", cellWidth: 25 }, //Employee name 
      1: { halign: "left", cellWidth: 25 },//Hrs
      2: { halign: "left", cellWidth: 45 },//Rate
      3: { halign: "right", cellWidth: 25 },//Rate
      4: { halign: "right", cellWidth: 25 },//Rate
      5: { halign: "right", cellWidth: 25 },//Rate
      6: { halign: "right", cellWidth: 25 },//Rate
      },
  })
 

    /* SILVER KATCHA */

    tempBody=[];
    var silKatcha= dataRows.filter(function (el) {
      return el.Remark == 'SILVER KATCHA';
    });
 var totalSilKatcha = [...silKatcha.reduce((r, o) => {
         const key = o.Remark.toString() ;
 
         const item = r.get(key) || Object.assign({}, o, {
          OpenWt: 0,
          RecWt: 0,
          HoTagWt: 0,
          BalanceWt: 0
         });
 
         item.OpenWt += o.OpenWt;
         item.RecWt += o.RecWt;
         item.HoTagWt += o.HoTagWt;
         item.BalanceWt += o.BalanceWt;
 
         return r.set(key, item);
  }, new Map).values()];
 
    
  if(totalSilKatcha.length>0){
      tempBody.push({
        LotNo: '',
        LotDate: '',
        AccDesc: 'SILVER KATCHA',
        Opening: totalSilKatcha[0].OpenWt,
        Receipt: totalSilKatcha[0].RecWt,
        Issue: totalSilKatcha[0].HoTagWt,
        Closing: totalSilKatcha[0].BalanceWt,
      })
  }
    
 
 
 for (var i=0;i<=silKatcha.length-1;i++){
  
      var lotDate=moment(silKatcha[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
      lotDate="";
      }
        tempBody.push({
          LotNo: silKatcha[i].LotNo,
          LotDate: lotDate,
          AccDesc: silKatcha[i].AccDesc,
          Opening: silKatcha[i].OpenWt,
          Receipt: silKatcha[i].RecWt,
          Issue: silKatcha[i].HoTagWt,
          Closing: silKatcha[i].BalanceWt,
        })
 
 }
 
 if (tempBody.length>0){
  pdfYpos=pdfYpos+bodyHeight;
 }

 if (pdfYpos >= 250) {
  pdfYpos = 20;
  pdfDoc.addPage('p');
}
 
 
  autoTable(pdfDoc, {
    startY: pdfYpos,
    head: [],
    body: tempBody,
    tableWidth: 200,
    margin: {
      top: 20,
      bottom: 20,
      left: 10,
      right: 10,
      width: 200
  },
  willDrawCell: function (data) {
    if (data.row.section === 'body') {
        var height = (data.table.body.length) * data.table.body[0].height;
        bodyHeight = height;
    }
    if (data.row.index == 0) {
    if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
 
      if (data.cell.raw == "SILVER KATCHA") {
        pdfDoc.setFontSize(9);
        pdfDoc.setTextColor(128, 0, 0);
        pdfDoc.setFont("Times", "bold");
      }
      else
      {
        pdfDoc.setFontSize(9);
        pdfDoc.setFont("Times", "bold");
      }
    }
 
  }
 },
  styles: {
    overflow: 'linebreak', cellwidth: 'auto'
  },
  headStyles: {
      fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
  },
  theme: "grid",
  bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
 
  columnStyles: {
      0: { halign: "left", cellWidth: 25 }, //Employee name 
      1: { halign: "left", cellWidth: 25 },//Hrs
      2: { halign: "left", cellWidth: 45 },//Rate
      3: { halign: "right", cellWidth: 25 },//Rate
      4: { halign: "right", cellWidth: 25 },//Rate
      5: { halign: "right", cellWidth: 25 },//Rate
      6: { halign: "right", cellWidth: 25 },//Rate
      },
  })


      /* MELTING GOLD */

      tempBody=[];
      var meltGold= dataRows.filter(function (el) {
        return el.Remark == 'MELTING GOLD';
      });
   var totalMeltGold = [...meltGold.reduce((r, o) => {
           const key = o.Remark.toString() ;
   
           const item = r.get(key) || Object.assign({}, o, {
            OpenWt: 0,
            RecWt: 0,
            HoTagWt: 0,
            BalanceWt: 0
           });
   
           item.OpenWt += o.OpenWt;
           item.RecWt += o.RecWt;
           item.HoTagWt += o.HoTagWt;
           item.BalanceWt += o.BalanceWt;
   
           return r.set(key, item);
    }, new Map).values()];
   
      
    if(totalMeltGold.length>0){
        tempBody.push({
          LotNo: '',
          LotDate: '',
          AccDesc: 'MELTING GOLD',
          Opening: totalMeltGold[0].OpenWt,
          Receipt: totalMeltGold[0].RecWt,
          Issue: totalMeltGold[0].HoTagWt,
          Closing: totalMeltGold[0].BalanceWt,
        })
    }
      
   
   
   for (var i=0;i<=meltGold.length-1;i++){
    
        var lotDate=moment(meltGold[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
        if (lotDate=="01-01-1900"){
        lotDate="";
        }
          tempBody.push({
            LotNo: meltGold[i].LotNo,
            LotDate: lotDate,
            AccDesc: meltGold[i].AccDesc,
            Opening: meltGold[i].OpenWt,
            Receipt: meltGold[i].RecWt,
            Issue: meltGold[i].HoTagWt,
            Closing: meltGold[i].BalanceWt,
          })
   
   }
   
   if (tempBody.length>0){
    pdfYpos=pdfYpos+bodyHeight;
   }

   if (pdfYpos >= 250) {
    pdfYpos = 20;
    pdfDoc.addPage('p');
  }
   
   
    autoTable(pdfDoc, {
      startY: pdfYpos,
      head: [],
      body: tempBody,
      tableWidth: 200,
      margin: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
        width: 200
    },
    willDrawCell: function (data) {
      if (data.row.section === 'body') {
          var height = (data.table.body.length) * data.table.body[0].height;
          bodyHeight = height;
      }
      if (data.row.index == 0) {
      if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
   
        if (data.cell.raw == "MELTING GOLD") {
          pdfDoc.setFontSize(9);
          pdfDoc.setTextColor(128, 0, 0);
          pdfDoc.setFont("Times", "bold");
        }
        else
        {
          pdfDoc.setFontSize(9);
          pdfDoc.setFont("Times", "bold");
        }
      }
   
    }
   },
    styles: {
      overflow: 'linebreak', cellwidth: 'auto'
    },
    headStyles: {
        fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
    },
    theme: "grid",
    bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
   
    columnStyles: {
        0: { halign: "left", cellWidth: 25 }, //Employee name 
        1: { halign: "left", cellWidth: 25 },//Hrs
        2: { halign: "left", cellWidth: 45 },//Rate
        3: { halign: "right", cellWidth: 25 },//Rate
        4: { halign: "right", cellWidth: 25 },//Rate
        5: { halign: "right", cellWidth: 25 },//Rate
        6: { halign: "right", cellWidth: 25 },//Rate
        },
    })
  

      /* MELTING SILVER */

      tempBody=[];
      var meltSilver= dataRows.filter(function (el) {
        return el.Remark == 'MELTING SILVER';
      });
   var totalMeltSilver = [...meltSilver.reduce((r, o) => {
           const key = o.Remark.toString() ;
   
           const item = r.get(key) || Object.assign({}, o, {
            OpenWt: 0,
            RecWt: 0,
            HoTagWt: 0,
            BalanceWt: 0
           });
   
           item.OpenWt += o.OpenWt;
           item.RecWt += o.RecWt;
           item.HoTagWt += o.HoTagWt;
           item.BalanceWt += o.BalanceWt;
   
           return r.set(key, item);
    }, new Map).values()];
   
      
    if(totalMeltSilver.length>0){
        tempBody.push({
          LotNo: '',
          LotDate: '',
          AccDesc: 'MELTING SILVER',
          Opening: totalMeltSilver[0].OpenWt,
          Receipt: totalMeltSilver[0].RecWt,
          Issue: totalMeltSilver[0].HoTagWt,
          Closing: totalMeltSilver[0].BalanceWt,
        })
    }
      
   
   
   for (var i=0;i<=meltSilver.length-1;i++){
    
        var lotDate=moment(meltSilver[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
        if (lotDate=="01-01-1900"){
        lotDate="";
        }
          tempBody.push({
            LotNo: meltSilver[i].LotNo,
            LotDate: lotDate,
            AccDesc: meltSilver[i].AccDesc,
            Opening: meltSilver[i].OpenWt,
            Receipt: meltSilver[i].RecWt,
            Issue: meltSilver[i].HoTagWt,
            Closing: meltSilver[i].BalanceWt,
          })
   
   }
   
   if (tempBody.length>0){
    pdfYpos=pdfYpos+bodyHeight;
   }

   if (pdfYpos >= 250) {
    pdfYpos = 20;
    pdfDoc.addPage('p');
  }
   
   
    autoTable(pdfDoc, {
      startY: pdfYpos,
      head: [],
      body: tempBody,
      tableWidth: 200,
      margin: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
        width: 200
    },
    willDrawCell: function (data) {
      if (data.row.section === 'body') {
          var height = (data.table.body.length) * data.table.body[0].height;
          bodyHeight = height;
      }
      if (data.row.index == 0) {
      if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
   
        if (data.cell.raw == "MELTING SILVER") {
          pdfDoc.setFontSize(9);
          pdfDoc.setTextColor(128, 0, 0);
          pdfDoc.setFont("Times", "bold");
        }
        else
        {
          pdfDoc.setFontSize(9);
          pdfDoc.setFont("Times", "bold");
        }
      }
   
    }
   },
    styles: {
      overflow: 'linebreak', cellwidth: 'auto'
    },
    headStyles: {
        fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
    },
    theme: "grid",
    bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
   
    columnStyles: {
        0: { halign: "left", cellWidth: 25 }, //Employee name 
        1: { halign: "left", cellWidth: 25 },//Hrs
        2: { halign: "left", cellWidth: 45 },//Rate
        3: { halign: "right", cellWidth: 25 },//Rate
        4: { halign: "right", cellWidth: 25 },//Rate
        5: { halign: "right", cellWidth: 25 },//Rate
        6: { halign: "right", cellWidth: 25 },//Rate
        },
    })


      /* SB IN GOLD */

      tempBody=[];
      var sbInGold= dataRows.filter(function (el) {
        return el.Remark == 'SB IN GOLD';
      });
   var totalsbInGold = [...sbInGold.reduce((r, o) => {
           const key = o.Remark.toString() ;
   
           const item = r.get(key) || Object.assign({}, o, {
            OpenWt: 0,
            RecWt: 0,
            HoTagWt: 0,
            BalanceWt: 0
           });
   
           item.OpenWt += o.OpenWt;
           item.RecWt += o.RecWt;
           item.HoTagWt += o.HoTagWt;
           item.BalanceWt += o.BalanceWt;
   
           return r.set(key, item);
    }, new Map).values()];
   
      
    if(totalsbInGold.length>0){
        tempBody.push({
          LotNo: '',
          LotDate: '',
          AccDesc: 'SB IN GOLD',
          Opening: totalsbInGold[0].OpenWt,
          Receipt: totalsbInGold[0].RecWt,
          Issue: totalsbInGold[0].HoTagWt,
          Closing: totalsbInGold[0].BalanceWt,
        })
    }
      
   
   
   for (var i=0;i<=sbInGold.length-1;i++){
    
        var lotDate=moment(sbInGold[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
        if (lotDate=="01-01-1900"){
        lotDate="";
        }
          tempBody.push({
            LotNo: sbInGold[i].LotNo,
            LotDate: lotDate,
            AccDesc: sbInGold[i].AccDesc,
            Opening: sbInGold[i].OpenWt,
            Receipt: sbInGold[i].RecWt,
            Issue: sbInGold[i].HoTagWt,
            Closing: sbInGold[i].BalanceWt,
          })
   
   }
   
   if (tempBody.length>0){
    pdfYpos=pdfYpos+bodyHeight;
   }

   if (pdfYpos >= 250) {
    pdfYpos = 20;
    pdfDoc.addPage('p');
  }
   
   
    autoTable(pdfDoc, {
      startY: pdfYpos,
      head: [],
      body: tempBody,
      tableWidth: 200,
      margin: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
        width: 200
    },
    willDrawCell: function (data) {
      if (data.row.section === 'body') {
          var height = (data.table.body.length) * data.table.body[0].height;
          bodyHeight = height;
      }
      if (data.row.index == 0) {
      if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
   
        if (data.cell.raw == "SB IN GOLD") {
          pdfDoc.setFontSize(9);
          pdfDoc.setTextColor(128, 0, 0);
          pdfDoc.setFont("Times", "bold");
        }
        else
        {
          pdfDoc.setFontSize(9);
          pdfDoc.setFont("Times", "bold");
        }
      }
   
    }
   },
    styles: {
      overflow: 'linebreak', cellwidth: 'auto'
    },
    headStyles: {
        fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
    },
    theme: "grid",
    bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
   
    columnStyles: {
        0: { halign: "left", cellWidth: 25 }, //Employee name 
        1: { halign: "left", cellWidth: 25 },//Hrs
        2: { halign: "left", cellWidth: 45 },//Rate
        3: { halign: "right", cellWidth: 25 },//Rate
        4: { halign: "right", cellWidth: 25 },//Rate
        5: { halign: "right", cellWidth: 25 },//Rate
        6: { halign: "right", cellWidth: 25 },//Rate
        },
    })


          /* SB IN SILVER */

          tempBody=[];
          var sbInSilver= dataRows.filter(function (el) {
            return el.Remark == 'SB IN SILVER';
          });
       var totalsbInSilver = [...sbInSilver.reduce((r, o) => {
               const key = o.Remark.toString() ;
       
               const item = r.get(key) || Object.assign({}, o, {
                OpenWt: 0,
                RecWt: 0,
                HoTagWt: 0,
                BalanceWt: 0
               });
       
               item.OpenWt += o.OpenWt;
               item.RecWt += o.RecWt;
               item.HoTagWt += o.HoTagWt;
               item.BalanceWt += o.BalanceWt;
       
               return r.set(key, item);
        }, new Map).values()];
       
          
        if(totalsbInSilver.length>0){
            tempBody.push({
              LotNo: '',
              LotDate: '',
              AccDesc: 'SB IN SILVER',
              Opening: totalsbInSilver[0].OpenWt,
              Receipt: totalsbInSilver[0].RecWt,
              Issue: totalsbInSilver[0].HoTagWt,
              Closing: totalsbInSilver[0].BalanceWt,
            })
        }
          
       
       
       for (var i=0;i<=sbInSilver.length-1;i++){
        
            var lotDate=moment(sbInSilver[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
            if (lotDate=="01-01-1900"){
            lotDate="";
            }
              tempBody.push({
                LotNo: sbInSilver[i].LotNo,
                LotDate: lotDate,
                AccDesc: sbInSilver[i].AccDesc,
                Opening: sbInSilver[i].OpenWt,
                Receipt: sbInSilver[i].RecWt,
                Issue: sbInSilver[i].HoTagWt,
                Closing: sbInSilver[i].BalanceWt,
              })
       
       }
       
       if (tempBody.length>0){
        pdfYpos=pdfYpos+bodyHeight;
       }

       if (pdfYpos >= 250) {
        pdfYpos = 20;
        pdfDoc.addPage('p');
      }
       
       
        autoTable(pdfDoc, {
          startY: pdfYpos,
          head: [],
          body: tempBody,
          tableWidth: 200,
          margin: {
            top: 20,
            bottom: 20,
            left: 10,
            right: 10,
            width: 200
        },
        willDrawCell: function (data) {
          if (data.row.section === 'body') {
              var height = (data.table.body.length) * data.table.body[0].height;
              bodyHeight = height;
          }
          if (data.row.index == 0) {
          if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
       
            if (data.cell.raw == "SB IN SILVER") {
              pdfDoc.setFontSize(9);
              pdfDoc.setTextColor(128, 0, 0);
              pdfDoc.setFont("Times", "bold");
            }
            else
            {
              pdfDoc.setFontSize(9);
              pdfDoc.setFont("Times", "bold");
            }
          }
       
        }
       },
        styles: {
          overflow: 'linebreak', cellwidth: 'auto'
        },
        headStyles: {
            fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
        },
        theme: "grid",
        bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
       
        columnStyles: {
            0: { halign: "left", cellWidth: 25 }, //Employee name 
            1: { halign: "left", cellWidth: 25 },//Hrs
            2: { halign: "left", cellWidth: 45 },//Rate
            3: { halign: "right", cellWidth: 25 },//Rate
            4: { halign: "right", cellWidth: 25 },//Rate
            5: { halign: "right", cellWidth: 25 },//Rate
            6: { halign: "right", cellWidth: 25 },//Rate
            },
        })
    

              /* DEALER GOLD */

                  tempBody=[];
                  var dealerGold= dataRows.filter(function (el) {
                    return el.Remark == 'DEALER GOLD';
                  });
               var totaldealerGold = [...dealerGold.reduce((r, o) => {
                       const key = o.Remark.toString() ;
               
                       const item = r.get(key) || Object.assign({}, o, {
                        OpenWt: 0,
                        RecWt: 0,
                        HoTagWt: 0,
                        BalanceWt: 0
                       });
               
                       item.OpenWt += o.OpenWt;
                       item.RecWt += o.RecWt;
                       item.HoTagWt += o.HoTagWt;
                       item.BalanceWt += o.BalanceWt;
               
                       return r.set(key, item);
                }, new Map).values()];
               
                  
                if(totaldealerGold.length>0){
                    tempBody.push({
                      LotNo: '',
                      LotDate: '',
                      AccDesc: 'DEALER GOLD',
                      Opening: totaldealerGold[0].OpenWt,
                      Receipt: totaldealerGold[0].RecWt,
                      Issue: totaldealerGold[0].HoTagWt,
                      Closing: totaldealerGold[0].BalanceWt,
                    })
                }
                  
               
               
               for (var i=0;i<=dealerGold.length-1;i++){
                
                    var lotDate=moment(dealerGold[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
                    if (lotDate=="01-01-1900"){
                    lotDate="";
                    }
                      tempBody.push({
                        LotNo: dealerGold[i].LotNo,
                        LotDate: lotDate,
                        AccDesc: dealerGold[i].AccDesc,
                        Opening: dealerGold[i].OpenWt,
                        Receipt: dealerGold[i].RecWt,
                        Issue: dealerGold[i].HoTagWt,
                        Closing: dealerGold[i].BalanceWt,
                      })
               
               }
               
               if (tempBody.length>0){
                pdfYpos=pdfYpos+bodyHeight;
               }
               
                autoTable(pdfDoc, {
                  startY: pdfYpos,
                  head: [],
                  body: tempBody,
                  tableWidth: 200,
                  margin: {
                    top: 20,
                    bottom: 20,
                    left: 10,
                    right: 10,
                    width: 200
                },
                willDrawCell: function (data) {
                  if (data.row.section === 'body') {
                      var height = (data.table.body.length) * data.table.body[0].height;
                      bodyHeight = height;
                  }
                  if (data.row.index == 0) {
                  if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
               
                    if (data.cell.raw == "DEALER GOLD") {
                      pdfDoc.setFontSize(9);
                      pdfDoc.setTextColor(128, 0, 0);
                      pdfDoc.setFont("Times", "bold");
                    }
                    else
                    {
                      pdfDoc.setFontSize(9);
                      pdfDoc.setFont("Times", "bold");
                    }
                  }
               
                }
               },
                styles: {
                  overflow: 'linebreak', cellwidth: 'auto'
                },
                headStyles: {
                    fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
                },
                theme: "grid",
                bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
               
                columnStyles: {
                    0: { halign: "left", cellWidth: 25 }, //Employee name 
                    1: { halign: "left", cellWidth: 25 },//Hrs
                    2: { halign: "left", cellWidth: 45 },//Rate
                    3: { halign: "right", cellWidth: 25 },//Rate
                    4: { halign: "right", cellWidth: 25 },//Rate
                    5: { halign: "right", cellWidth: 25 },//Rate
                    6: { halign: "right", cellWidth: 25 },//Rate
                    },
                })
        


              /* DEALER SILVER */

              tempBody=[];
              var dealerSilver= dataRows.filter(function (el) {
                return el.Remark == 'DEALER SILVER';
              });
           var totaldealerSilver = [...dealerSilver.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
           
              
            if(totaldealerSilver.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'DEALER SILVER',
                  Opening: totaldealerSilver[0].OpenWt,
                  Receipt: totaldealerSilver[0].RecWt,
                  Issue: totaldealerSilver[0].HoTagWt,
                  Closing: totaldealerSilver[0].BalanceWt,
                })
            }
              
           
           
           for (var i=0;i<=dealerSilver.length-1;i++){
            
                var lotDate=moment(dealerSilver[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
                if (lotDate=="01-01-1900"){
                lotDate="";
                }
                  tempBody.push({
                    LotNo: dealerSilver[i].LotNo,
                    LotDate: lotDate,
                    AccDesc: dealerSilver[i].AccDesc,
                    Opening: dealerSilver[i].OpenWt,
                    Receipt: dealerSilver[i].RecWt,
                    Issue: dealerSilver[i].HoTagWt,
                    Closing: dealerSilver[i].BalanceWt,
                  })
           
           }
           
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }

           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "DEALER SILVER") {
                  pdfDoc.setFontSize(9);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(9);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })

              /* SMITH GOLD */

              tempBody=[];
              var smithGold= dataRows.filter(function (el) {
                return el.Remark == 'SMITH GOLD' ;
              });
           var totalsmithGold = [...smithGold.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
           
              
            if(totalsmithGold.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'SMITH GOLD',
                  Opening: totalsmithGold[0].OpenWt,
                  Receipt: totalsmithGold[0].RecWt,
                  Issue: totalsmithGold[0].HoTagWt,
                  Closing: totalsmithGold[0].BalanceWt,
                })
            }
              
           
           
           for (var i=0;i<=smithGold.length-1;i++){
            
                var lotDate=moment(smithGold[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
                if (lotDate=="01-01-1900"){
                lotDate="";
                }
                  tempBody.push({
                    LotNo: smithGold[i].LotNo,
                    LotDate: lotDate,
                    AccDesc: smithGold[i].AccDesc,
                    Opening: smithGold[i].OpenWt,
                    Receipt: smithGold[i].RecWt,
                    Issue: smithGold[i].HoTagWt,
                    Closing: smithGold[i].BalanceWt,
                  })
           
           }
           
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }
           
           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "SMITH GOLD") {
                  pdfDoc.setFontSize(9);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(9);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })

            //
                          /* SMITH PARTY */

                          tempBody=[];
                          var smithParty= dataRows.filter(function (el) {
                            return el.Remark == 'SMITH PARTY' ;
                          });
                       var totalsmithParty = [...smithParty.reduce((r, o) => {
                               const key = o.Remark.toString() ;
                       
                               const item = r.get(key) || Object.assign({}, o, {
                                OpenWt: 0,
                                RecWt: 0,
                                HoTagWt: 0,
                                BalanceWt: 0
                               });
                       
                               item.OpenWt += o.OpenWt;
                               item.RecWt += o.RecWt;
                               item.HoTagWt += o.HoTagWt;
                               item.BalanceWt += o.BalanceWt;
                       
                               return r.set(key, item);
                        }, new Map).values()];
                       
                          
                        if(totalsmithParty.length>0){
                            tempBody.push({
                              LotNo: '',
                              LotDate: '',
                              AccDesc: 'SMITH PARTY',
                              Opening: totalsmithParty[0].OpenWt,
                              Receipt: totalsmithParty[0].RecWt,
                              Issue: totalsmithParty[0].HoTagWt,
                              Closing: totalsmithParty[0].BalanceWt,
                            })
                        }
                          
                       
                       
                       for (var i=0;i<=smithParty.length-1;i++){
                        
                            var lotDate=moment(smithParty[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
                            if (lotDate=="01-01-1900"){
                            lotDate="";
                            }
                              tempBody.push({
                                LotNo: smithParty[i].LotNo,
                                LotDate: lotDate,
                                AccDesc: smithParty[i].AccDesc,
                                Opening: smithParty[i].OpenWt,
                                Receipt: smithParty[i].RecWt,
                                Issue: smithParty[i].HoTagWt,
                                Closing: smithParty[i].BalanceWt,
                              })
                       
                       }
                       
                       if (tempBody.length>0){
                        pdfYpos=pdfYpos+bodyHeight;
                       }
                       
                        autoTable(pdfDoc, {
                          startY: pdfYpos,
                          head: [],
                          body: tempBody,
                          tableWidth: 200,
                          margin: {
                            top: 20,
                            bottom: 20,
                            left: 10,
                            right: 10,
                            width: 200
                        },
                        willDrawCell: function (data) {
                          if (data.row.section === 'body') {
                              var height = (data.table.body.length) * data.table.body[0].height;
                              bodyHeight = height;
                          }
                          if (data.row.index == 0) {
                          if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
                       
                            if (data.cell.raw == "SMITH PARTY") {
                              pdfDoc.setFontSize(9);
                              pdfDoc.setTextColor(128, 0, 0);
                              pdfDoc.setFont("Times", "bold");
                            }
                            else
                            {
                              pdfDoc.setFontSize(9);
                              pdfDoc.setFont("Times", "bold");
                            }
                          }
                       
                        }
                       },
                        styles: {
                          overflow: 'linebreak', cellwidth: 'auto'
                        },
                        headStyles: {
                            fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
                        },
                        theme: "grid",
                        bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
                       
                        columnStyles: {
                            0: { halign: "left", cellWidth: 25 }, //Employee name 
                            1: { halign: "left", cellWidth: 25 },//Hrs
                            2: { halign: "left", cellWidth: 45 },//Rate
                            3: { halign: "right", cellWidth: 25 },//Rate
                            4: { halign: "right", cellWidth: 25 },//Rate
                            5: { halign: "right", cellWidth: 25 },//Rate
                            6: { halign: "right", cellWidth: 25 },//Rate
                            },
                        })
            

              /* SMITH SILVER */

              tempBody=[];
              var smithSilver= dataRows.filter(function (el) {
                return el.Remark == 'SMITH SILVER';
              });
           var totalSmithSilver = [...smithSilver.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalSmithSilver.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'SMITH SILVER',
                  Opening: totalSmithSilver[0].OpenWt,
                  Receipt: totalSmithSilver[0].RecWt,
                  Issue: totalSmithSilver[0].HoTagWt,
                  Closing: totalSmithSilver[0].BalanceWt,
                })
            }
           
           for (var i=0;i<=smithSilver.length-1;i++){
            
                var lotDate=moment(smithSilver[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
                if (lotDate=="01-01-1900"){
                lotDate="";
                }
                  tempBody.push({
                    LotNo: smithSilver[i].LotNo,
                    LotDate: lotDate,
                    AccDesc: smithSilver[i].AccDesc,
                    Opening: smithSilver[i].OpenWt,
                    Receipt: smithSilver[i].RecWt,
                    Issue: smithSilver[i].HoTagWt,
                    Closing: smithSilver[i].BalanceWt,
                  })
           }
           
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }

           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "SMITH SILVER") {
                  pdfDoc.setFontSize(9);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(9);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })


              /*BRANCH OFFICE GOLD WEIGHT */

              tempBody=[];
              var boGoldWt= dataRows.filter(function (el) {
                return el.Remark.includes('GOLD WT') && el.Id == 14;
              });
           var totalboGoldWt = [...boGoldWt.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalboGoldWt.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'BRANCH OFFICE GOLD WT',
                  Opening: totalboGoldWt[0].OpenWt,
                  Receipt: totalboGoldWt[0].RecWt,
                  Issue: totalboGoldWt[0].HoTagWt,
                  Closing: totalboGoldWt[0].BalanceWt,
                })
            }
           
                    
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }
           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "BRANCH OFFICE GOLD WT") {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })


              /*BRANCH OFFICE SILVER WEIGHT */

              tempBody=[];
              var boSilverWt= dataRows.filter(function (el) {
                return el.Remark.includes('SILVER WT') && el.Id == 15;
              });
           var totalboSilverWt = [...boSilverWt.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalboSilverWt.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'BRANCH OFFICE SILVER WT',
                  Opening: totalboSilverWt[0].OpenWt,
                  Receipt: totalboSilverWt[0].RecWt,
                  Issue: totalboSilverWt[0].HoTagWt,
                  Closing: totalboSilverWt[0].BalanceWt,
                })
            }
           
                    
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }

           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "BRANCH OFFICE SILVER WT") {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })


                /*GANDHIPURAM OFFICE GOLD WEIGHT */

                    tempBody=[];
                    var gpGoldWt= dataRows.filter(function (el) {
                      return el.Remark.includes('GOLD WT') && el.Id == 16;
                    });
                  var totalgpGoldWt = [...gpGoldWt.reduce((r, o) => {
                          const key = o.Remark.toString() ;
                  
                          const item = r.get(key) || Object.assign({}, o, {
                          OpenWt: 0,
                          RecWt: 0,
                          HoTagWt: 0,
                          BalanceWt: 0
                          });
                  
                          item.OpenWt += o.OpenWt;
                          item.RecWt += o.RecWt;
                          item.HoTagWt += o.HoTagWt;
                          item.BalanceWt += o.BalanceWt;
                  
                          return r.set(key, item);
                  }, new Map).values()];
                          
                        if(totalgpGoldWt.length>0){
                            tempBody.push({
                              LotNo: '',
                              LotDate: '',
                              AccDesc: 'GANDHI PURAM GOLD WT',
                              Opening: totalgpGoldWt[0].OpenWt,
                              Receipt: totalgpGoldWt[0].RecWt,
                              Issue: totalgpGoldWt[0].HoTagWt,
                              Closing: totalgpGoldWt[0].BalanceWt,
                            })
                        }
                       
                                
                       if (tempBody.length>0){
                        pdfYpos=pdfYpos+bodyHeight;
                       }

                       if (pdfYpos >= 250) {
                        pdfYpos = 20;
                        pdfDoc.addPage('p');
                      }
                       
                       
                        autoTable(pdfDoc, {
                          startY: pdfYpos,
                          head: [],
                          body: tempBody,
                          tableWidth: 200,
                          margin: {
                            top: 20,
                            bottom: 20,
                            left: 10,
                            right: 10,
                            width: 200
                        },
                        willDrawCell: function (data) {
                          if (data.row.section === 'body') {
                              var height = (data.table.body.length) * data.table.body[0].height;
                              bodyHeight = height;
                          }
                          if (data.row.index == 0) {
                          if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
                       
                            if (data.cell.raw == "GANDHI PURAM GOLD WT") {
                              pdfDoc.setFontSize(8);
                              pdfDoc.setTextColor(128, 0, 0);
                              pdfDoc.setFont("Times", "bold");
                            }
                            else
                            {
                              pdfDoc.setFontSize(8);
                              pdfDoc.setFont("Times", "bold");
                            }
                          }
                       
                        }
                       },
                        styles: {
                          overflow: 'linebreak', cellwidth: 'auto'
                        },
                        headStyles: {
                            fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
                        },
                        theme: "grid",
                        bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
                       
                        columnStyles: {
                            0: { halign: "left", cellWidth: 25 }, //Employee name 
                            1: { halign: "left", cellWidth: 25 },//Hrs
                            2: { halign: "left", cellWidth: 45 },//Rate
                            3: { halign: "right", cellWidth: 25 },//Rate
                            4: { halign: "right", cellWidth: 25 },//Rate
                            5: { halign: "right", cellWidth: 25 },//Rate
                            6: { halign: "right", cellWidth: 25 },//Rate
                            },
                        })
            

                /*GANDHIPURAM OFFICE SILVER WEIGHT */

                tempBody=[];
                var gpSilverWt= dataRows.filter(function (el) {
                  return el.Remark.includes('SILVER WT') && el.Id == 17;
                });
              var totalgpSilverWt = [...gpSilverWt.reduce((r, o) => {
                      const key = o.Remark.toString() ;
              
                      const item = r.get(key) || Object.assign({}, o, {
                      OpenWt: 0,
                      RecWt: 0,
                      HoTagWt: 0,
                      BalanceWt: 0
                      });
              
                      item.OpenWt += o.OpenWt;
                      item.RecWt += o.RecWt;
                      item.HoTagWt += o.HoTagWt;
                      item.BalanceWt += o.BalanceWt;
              
                      return r.set(key, item);
              }, new Map).values()];
                      
                    if(totalgpSilverWt.length>0){
                        tempBody.push({
                          LotNo: '',
                          LotDate: '',
                          AccDesc: 'GANDHI PURAM SILVER WT',
                          Opening: totalgpSilverWt[0].OpenWt,
                          Receipt: totalgpSilverWt[0].RecWt,
                          Issue: totalgpSilverWt[0].HoTagWt,
                          Closing: totalgpSilverWt[0].BalanceWt,
                        })
                    }
                   
                            
                   if (tempBody.length>0){
                    pdfYpos=pdfYpos+bodyHeight;
                   }

                   if (pdfYpos >= 250) {
                    pdfYpos = 20;
                    pdfDoc.addPage('p');
                  }
                   
                   
                    autoTable(pdfDoc, {
                      startY: pdfYpos,
                      head: [],
                      body: tempBody,
                      tableWidth: 200,
                      margin: {
                        top: 20,
                        bottom: 20,
                        left: 10,
                        right: 10,
                        width: 200
                    },
                    willDrawCell: function (data) {
                      if (data.row.section === 'body') {
                          var height = (data.table.body.length) * data.table.body[0].height;
                          bodyHeight = height;
                      }
                      if (data.row.index == 0) {
                      if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
                   
                        if (data.cell.raw == "GANDHI PURAM SILVER WT") {
                          pdfDoc.setFontSize(8);
                          pdfDoc.setTextColor(128, 0, 0);
                          pdfDoc.setFont("Times", "bold");
                        }
                        else
                        {
                          pdfDoc.setFontSize(8);
                          pdfDoc.setFont("Times", "bold");
                        }
                      }
                   
                    }
                   },
                    styles: {
                      overflow: 'linebreak', cellwidth: 'auto'
                    },
                    headStyles: {
                        fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
                    },
                    theme: "grid",
                    bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
                   
                    columnStyles: {
                        0: { halign: "left", cellWidth: 25 }, //Employee name 
                        1: { halign: "left", cellWidth: 25 },//Hrs
                        2: { halign: "left", cellWidth: 45 },//Rate
                        3: { halign: "right", cellWidth: 25 },//Rate
                        4: { halign: "right", cellWidth: 25 },//Rate
                        5: { halign: "right", cellWidth: 25 },//Rate
                        6: { halign: "right", cellWidth: 25 },//Rate
                        },
                    })



              /*BRANCH OFFICE PENDING GOLD WEIGHT */

              tempBody=[];
              var boPendingGoldWt= dataRows.filter(function (el) {
                return el.Remark.includes('PENDING GOLD WT') && el.Id == 18;
              });
           var totalboPendingGoldWt = [...boPendingGoldWt.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalboPendingGoldWt.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'BRANCH OFFICE PENDING GOLD WT',
                  Opening: totalboPendingGoldWt[0].OpenWt,
                  Receipt: totalboPendingGoldWt[0].RecWt,
                  Issue: totalboPendingGoldWt[0].HoTagWt,
                  Closing: totalboPendingGoldWt[0].BalanceWt,
                })
            }
           
                    
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }

           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "BRANCH OFFICE PENDING GOLD WT") {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })

              /*BRANCH OFFICE PENDING SILVER WEIGHT */

              tempBody=[];
              var boPendingSilverWt= dataRows.filter(function (el) {
                return el.Remark.includes('PENDING SILVER WT') && el.Id == 19;
              });
           var totalboPendingSilverWt = [...boPendingSilverWt.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalboPendingSilverWt.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'BRANCH OFFICE PENDING SILVER WT',
                  Opening: totalboPendingSilverWt[0].OpenWt,
                  Receipt: totalboPendingSilverWt[0].RecWt,
                  Issue: totalboPendingSilverWt[0].HoTagWt,
                  Closing: totalboPendingSilverWt[0].BalanceWt,
                })
            }
           
                    
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }

           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "BRANCH OFFICE PENDING SILVER WT") {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })


              /*GANDHIPURAM OFFICE PENDING GOLD WEIGHT */

              tempBody=[];
              var GPPendingGoldWt= dataRows.filter(function (el) {
                return el.Remark.includes('PENDING GOLD WT') && el.Id == 20;
              });
           var totalGPPendingGoldWt = [...GPPendingGoldWt.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalGPPendingGoldWt.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'GANDHIPURAM PENDING GOLD WT',
                  Opening: totalGPPendingGoldWt[0].OpenWt,
                  Receipt: totalGPPendingGoldWt[0].RecWt,
                  Issue: totalGPPendingGoldWt[0].HoTagWt,
                  Closing: totalGPPendingGoldWt[0].BalanceWt,
                })
            }
           
                    
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }

           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "GANDHIPURAM PENDING GOLD WT") {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })            


              /*GANDHIPURAM OFFICE PENDING SILVER WEIGHT */

              tempBody=[];
              var GPPendingSilverWt= dataRows.filter(function (el) {
                return el.Remark.includes('PENDING SILVER WT') && el.Id == 21;
              });
           var totalGPPendingGoldWt = [...GPPendingSilverWt.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalGPPendingGoldWt.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'GANDHIPURAM PENDING SILVER WT',
                  Opening: totalGPPendingGoldWt[0].OpenWt,
                  Receipt: totalGPPendingGoldWt[0].RecWt,
                  Issue: totalGPPendingGoldWt[0].HoTagWt,
                  Closing: totalGPPendingGoldWt[0].BalanceWt,
                })
            }
           
                    
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }
           
           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "GANDHIPURAM PENDING SILVER WT") {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })            


              /*CASH C.O*/

              tempBody=[];
              var cashCO= dataRows.filter(function (el) {
                return el.Remark == 'CASH C.O';
              });
           var totalcashCO = [...cashCO.reduce((r, o) => {
                   const key = o.Remark.toString() ;
           
                   const item = r.get(key) || Object.assign({}, o, {
                    OpenWt: 0,
                    RecWt: 0,
                    HoTagWt: 0,
                    BalanceWt: 0
                   });
           
                   item.OpenWt += o.OpenWt;
                   item.RecWt += o.RecWt;
                   item.HoTagWt += o.HoTagWt;
                   item.BalanceWt += o.BalanceWt;
           
                   return r.set(key, item);
            }, new Map).values()];
              
            if(totalcashCO.length>0){
                tempBody.push({
                  LotNo: '',
                  LotDate: '',
                  AccDesc: 'CASH C.O',
                  Opening: totalcashCO[0].OpenWt,
                  Receipt: totalcashCO[0].RecWt,
                  Issue: totalcashCO[0].HoTagWt,
                  Closing: totalcashCO[0].BalanceWt,
                })
            }
           
                    
           if (tempBody.length>0){
            pdfYpos=pdfYpos+bodyHeight;
           }

           if (pdfYpos >= 250) {
            pdfYpos = 20;
            pdfDoc.addPage('p');
          }
           
           
            autoTable(pdfDoc, {
              startY: pdfYpos,
              head: [],
              body: tempBody,
              tableWidth: 200,
              margin: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10,
                width: 200
            },
            willDrawCell: function (data) {
              if (data.row.section === 'body') {
                  var height = (data.table.body.length) * data.table.body[0].height;
                  bodyHeight = height;
              }
              if (data.row.index == 0) {
              if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
           
                if (data.cell.raw == "CASH C.O") {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setTextColor(128, 0, 0);
                  pdfDoc.setFont("Times", "bold");
                }
                else
                {
                  pdfDoc.setFontSize(8);
                  pdfDoc.setFont("Times", "bold");
                }
              }
           
            }
           },
            styles: {
              overflow: 'linebreak', cellwidth: 'auto'
            },
            headStyles: {
                fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
            },
            theme: "grid",
            bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
           
            columnStyles: {
                0: { halign: "left", cellWidth: 25 }, //Employee name 
                1: { halign: "left", cellWidth: 25 },//Hrs
                2: { halign: "left", cellWidth: 45 },//Rate
                3: { halign: "right", cellWidth: 25 },//Rate
                4: { halign: "right", cellWidth: 25 },//Rate
                5: { halign: "right", cellWidth: 25 },//Rate
                6: { halign: "right", cellWidth: 25 },//Rate
                },
            })            



    /* BANK ACCOUNT */

    tempBody=[];
    var bankAccount= dataRows.filter(function (el) {
      return el.Remark == 'BANK ACCOUNT';
    });
 var totalbankAccount = [...bankAccount.reduce((r, o) => {
         const key = o.Remark.toString() ;
 
         const item = r.get(key) || Object.assign({}, o, {
          OpenWt: 0,
          RecWt: 0,
          HoTagWt: 0,
          BalanceWt: 0
         });
 
         item.OpenWt += o.OpenWt;
         item.RecWt += o.RecWt;
         item.HoTagWt += o.HoTagWt;
         item.BalanceWt += o.BalanceWt;
 
         return r.set(key, item);
  }, new Map).values()];
 
    
  if(totalbankAccount.length>0){
      tempBody.push({
        LotNo: '',
        LotDate: '',
        AccDesc: 'BANK ACCOUNT',
        Opening: totalbankAccount[0].OpenWt,
        Receipt: totalbankAccount[0].RecWt,
        Issue: totalbankAccount[0].HoTagWt,
        Closing: totalbankAccount[0].BalanceWt,
      })
  }
    
 
 
 for (var i=0;i<=bankAccount.length-1;i++){
  
      var lotDate=moment(bankAccount[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
      lotDate="";
      }
        tempBody.push({
          LotNo: bankAccount[i].LotNo,
          LotDate: lotDate,
          AccDesc: bankAccount[i].AccDesc,
          Opening: bankAccount[i].OpenWt,
          Receipt: bankAccount[i].RecWt,
          Issue: bankAccount[i].HoTagWt,
          Closing: bankAccount[i].BalanceWt,
        })
 
 }
 
 debugger;
 if (tempBody.length>0){
  pdfYpos=pdfYpos+bodyHeight;
 }

 if (pdfYpos >= 250) {
  pdfYpos = 20;
  pdfDoc.addPage('p');
}
 
 
  autoTable(pdfDoc, {
    startY: pdfYpos,
    head: [],
    body: tempBody,
    tableWidth: 200,
    margin: {
      top: 20,
      bottom: 20,
      left: 10,
      right: 10,
      width: 200
  },
  willDrawCell: function (data) {
    if (data.row.section === 'body') {
        var height = (data.table.body.length) * data.table.body[0].height;
        bodyHeight = height;
    }
    if (data.row.index == 0) {
    if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
 
      if (data.cell.raw == "BANK ACCOUNT") {
        pdfDoc.setFontSize(8);
        pdfDoc.setTextColor(128, 0, 0);
        pdfDoc.setFont("Times", "bold");
      }
      else
      {
        pdfDoc.setFontSize(8);
        pdfDoc.setFont("Times", "bold");
      }
    }
 
  }
 },
  styles: {
    overflow: 'linebreak', cellwidth: 'auto'
  },
  headStyles: {
      fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
  },
  theme: "grid",
  bodyStyles: { fontStyle: 'normal', fontSize: 7, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
 
  columnStyles: {
      0: { halign: "left", cellWidth: 25 }, //Employee name 
      1: { halign: "left", cellWidth: 25 },//Hrs
      2: { halign: "left", cellWidth: 45 },//Rate
      3: { halign: "right", cellWidth: 25 },//Rate
      4: { halign: "right", cellWidth: 25 },//Rate
      5: { halign: "right", cellWidth: 25 },//Rate
      6: { halign: "right", cellWidth: 25 },//Rate
      },
  })

    /* BANK ACCOUNT */

    tempBody=[];
    var bankAccount= dataRows.filter(function (el) {
      return el.Remark == 'BANK ACCOUNT';
    });
 var totalbankAccount = [...bankAccount.reduce((r, o) => {
         const key = o.Remark.toString() ;
 
         const item = r.get(key) || Object.assign({}, o, {
          OpenWt: 0,
          RecWt: 0,
          HoTagWt: 0,
          BalanceWt: 0
         });
 
         item.OpenWt += o.OpenWt;
         item.RecWt += o.RecWt;
         item.HoTagWt += o.HoTagWt;
         item.BalanceWt += o.BalanceWt;
 
         return r.set(key, item);
  }, new Map).values()];
 
    
  if(totalbankAccount.length>0){
      tempBody.push({
        LotNo: '',
        LotDate: '',
        AccDesc: 'BANK ACCOUNT',
        Opening: totalbankAccount[0].OpenWt,
        Receipt: totalbankAccount[0].RecWt,
        Issue: totalbankAccount[0].HoTagWt,
        Closing: totalbankAccount[0].BalanceWt,
      })
  }
    
 
 
 for (var i=0;i<=bankAccount.length-1;i++){
  
      var lotDate=moment(bankAccount[i].LotDate || '01-01-1900').format("DD-MM-YYYY") 
      if (lotDate=="01-01-1900"){
      lotDate="";
      }
        tempBody.push({
          LotNo: bankAccount[i].LotNo,
          LotDate: lotDate,
          AccDesc: bankAccount[i].AccDesc,
          Opening: bankAccount[i].OpenWt,
          Receipt: bankAccount[i].RecWt,
          Issue: bankAccount[i].HoTagWt,
          Closing: bankAccount[i].BalanceWt,
        })
 
 }
 
 if (tempBody.length>0){
  pdfYpos=pdfYpos+bodyHeight;
 }

 if (pdfYpos >= 250) {
  pdfYpos = 20;
  pdfDoc.addPage('p');
}
 
 
  autoTable(pdfDoc, {
    startY: pdfYpos,
    head: [],
    body: tempBody,
    tableWidth: 200,
    margin: {
      top: 20,
      bottom: 20,
      left: 10,
      right: 10,
      width: 200
  },
  willDrawCell: function (data) {
    if (data.row.section === 'body') {
        var height = (data.table.body.length) * data.table.body[0].height;
        bodyHeight = height;
    }
    if (data.row.index == 0) {
    if (data.row.section === 'body' && (data.column.dataKey === "AccDesc" || data.column.dataKey === "Opening" || data.column.dataKey === "Receipt" || data.column.dataKey === "Issue" || data.column.dataKey === "Closing" || data.column.dataKey === "Bold")) {
 
      if (data.cell.raw == "BANK ACCOUNT") {
        pdfDoc.setFontSize(8);
        pdfDoc.setTextColor(128, 0, 0);
        pdfDoc.setFont("Times", "bold");
      }
      else
      {
        pdfDoc.setFontSize(8);
        pdfDoc.setFont("Times", "bold");
      }
    }
 
  }
 },
  styles: {
    overflow: 'linebreak', cellwidth: 'auto'
  },
  headStyles: {
      fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
  },
  theme: "grid",
  bodyStyles: { fontStyle: 'normal', fontSize: 7, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
 
  columnStyles: {
      0: { halign: "left", cellWidth: 25 }, //Employee name 
      1: { halign: "left", cellWidth: 25 },//Hrs
      2: { halign: "left", cellWidth: 45 },//Rate
      3: { halign: "right", cellWidth: 25 },//Rate
      4: { halign: "right", cellWidth: 25 },//Rate
      5: { halign: "right", cellWidth: 25 },//Rate
      6: { halign: "right", cellWidth: 25 },//Rate
      },
  })




    addFooters(pdfDoc);
    //const iframe = doc.getElementById('docpdf');
    setsrcURL(pdfDoc.output('datauristring'));
    setShow1(true);
    //<iframe src={pdf.output('datauristring')}/>
    //pdf.save("testing.pdf");

  }

  catch (error) {
    console.log(error);
  }

}

async function GenereatePdf(){
  dataRows=[];
  let reportName=String(ReportNameRef.current)
  var results;
  setLoading(true);
  
  if (reportName=="Ornament Report All"){
    let postData = {
      "fromDate" :document.getElementById("txtFromDate").value,
      "toDate" : document.getElementById("txtToDate").value,
      "finyear" : Finyear
    }
      
    results = await apiService.postCall("smithreport/ornamentreportall",postData);
      
    if (results != "-1") {

      setLoading(false);
      setGridData(results.data[0]);
      dataRows=results.data[0];
      settotalCount(results.totalCount);
      setcurrentpg(postData.PageNumber);
      
      OrnamentReportAll();
    }
  }
  else if (reportName=="BO OJ Report"){
    let GroupId=String(GroupIdRef.current)
    var metal="";
    if (GroupId==1){
      metal="G"
    }
    else if (GroupId==2){
      metal="S"
    }
    else {
      metal="G"
    }


    let postData = {
      "fromDate" :document.getElementById("txtFromDate").value,
      "toDate" : document.getElementById("txtToDate").value,
      "BranchCode" : sessionStorage.getItem("BranchCode"),
      "metal" : metal
    }

    results = await apiService.postCall("smithreport/booldgoldwt",postData);
    debugger;
    if (results != "-1") {
      setLoading(false);
      setGridData(results.data[0]);
      dataRows=results.data[0];
      settotalCount(results.totalCount);
      setcurrentpg(postData.PageNumber);
      console.log(results.data[0])
      BOOldGoldWt();
    }

  }
  else if (reportName== "Touch Difference Report"){
    let postData = {
      "fromDate" :document.getElementById("txtFromDate").value,
      "toDate" : document.getElementById("txtToDate").value
    }

      results = await apiService.postCall("smithreport/touchdiffreport",postData);
      debugger;
      if (results != "-1") {
        setLoading(false);
        setGridData(results.data[0]);
        dataRows=results.data[0];
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
        console.log(results.data[0])
        tochDiffReport();
      }
  }
 
}


 async function SaveFunc(){
  try
  {
    setLoading(true);
     
   
      var results;

      
        let postData = {
          
          "fromDate" :document.getElementById("txtFromDate").value,
          "toDate" : document.getElementById("txtToDate").value,
          "finyear" : Finyear
        }
          
        let GroupId=String(GroupIdRef.current)
        if (GroupId==1){
          results = await apiService.postCall("smithreport/dealerledgergold",postData);
        }
        else {
          results = await apiService.postCall("smithreport/dealerledgersilver",postData);
        }
        
           

         
       
         if (results != "-1") {
           setLoading(false);
           setGridData(results.data[0]);
           dataRows=results.data[0];
           settotalCount(results.totalCount);
           setcurrentpg(postData.PageNumber);
           console.log(results.data[0])
         }
  
  
setLoading(false);
 if (results != "-1" && results !=undefined) {

if(results.errorCode=="8888")
{


swal({

  title: "Alert",
  text: results.data,
  icon: "info",
  button: "Ok"
  
}).then(function () {
  
});

return;

}  

 
    }
  }
  catch (error) {
    console.log(error);
  }

}



  
const columns=[
 
  {
    field: 'AccCode',
  headerName: 'Account Code',
  width: 150,
  align: 'left',
  headerAlign: 'left',
  editable: true,
  
  },
  {
    field: 'AccDesc',
    headerName: 'Party Name',
    align: 'left',
   headerAlign: 'left',
   editable: false,
   width: 400,
    },
  {
    field: 'Closing',
    headerName: 'Closing',
    align: 'left',
    headerAlign: 'left',
    editable: false,
    width: 200,
    }
    
   
]

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
                      
              <div className="header-title">
                <h4 className="card-title">Reports All</h4>
              </div>
             
              {/* <Modal {...props}  size="lg"
            aria-labelledby="contained-modal-title-vcenter"
             centered show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Dealer Ledger</Modal.Title>
                   
                  </Modal.Header>
                  <Modal.Body>
                  <iframe  id="docpdf"  src={srcURL} 
                         height="500"
                         width="720"
                         allowFullScreen={true}/>

                  </Modal.Body>
                </Modal> */}


            </Card.Header>

            <Card.Body>

                        
            <div className='container-fluid py-4 '>
                    <div className='row py-2'> 

                       <div className='col-md-4'>
                            <Form.Label>From Date</Form.Label>
                            <Form.Control type="date" id="txtFromDate" placeholder="" defaultValue={defaultValue} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>To Date</Form.Label>
                            <Form.Control type="date"  id="txtToDate" placeholder="" defaultValue={defaultValue} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Metal</Form.Label>
                             <Select className="" id="txtMetal" 
                             options={DtUserGroup}
                             isDisabled={isDisabled}
                             value={DtUserGroup.filter(function(option) {
                              return option.value === GroupId;
                            })}
                            onChange=
                            {
                              (e) => {
                                  setGroupId(e.value);
                                 setGridData([]);
                              }
                              }
                             disabled={false}>
              								
							               </Select>

                          
                        </div>
                        
                        </div>
                        <div className='row py-1'>
                        <div className='col-md-6'>
                        <Form.Label>Report Name</Form.Label>
                          <Select options={reportOptions} id="txtReportName"  onChange=
                            {
                              (e) => {
                              setReportName(e.label);
                              }
                              }/>
                        </div>
                        <div className='col-md-6' style={{marginTop : 35}}>
                         
                         {/* <Button type="button" variant="contained" onClick={SaveFunc}>View</Button> &nbsp;&nbsp;&nbsp; */}
                         <Button type="button"  variant="contained" onClick={GenereatePdf}>Print</Button>
                     
                         
                         </div>


                        </div>
                      </div>

                        <div className='pt-1' style={{ direction: 'rtl' }} >
                       
                        <Form.Group className="form-group">
                  
                 
               
                  
                </Form.Group>
             

              </div>

        <Box sx={{ height: 400, width: 1,
               '.MuiDataGrid-columnHeaderTitle': { 
                fontWeight: 'bold !important',
                overflow: 'visible !important'
             },
             '& .super-app-theme--cell': {
              backgroundColor: 'rgba(157, 255, 118, 0.49)',
              color: '#1a3e72',
              fontWeight: '600',
            },
            '& .super-app.positive': {
              backgroundColor: '#d47483',
              color: '#1a3e72',
              fontWeight: '600',
            },
              }}>
                  {/* <StyledDataGrid
                   //checkboxSelection
                   editMode="row"
                    rows={GridData}
                    columns={columns}
                    getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                    getRowId={(row) =>  row.AccCode}
                     showCellVerticalBorder 
                     showColumnVerticalBorder 
                     loading={loading}
                    slots={{ toolbar: GridToolbar }}
                   
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10
                        }
                      }
                    }}

                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      
                      },
                    }}
                  /> */}

                
      <div className="container rsvp-wrapper">
                    {loading ?  (
        <Button   variant="primary" disabled style={{justifyContent: "center",alignItems:"center"}}>
        <Spinner style={{ height: 50, width: 50}}  className="loading text-center"
            name="three-bounce"
            color="white"
            fadeIn="none"
            /> Loading... </Button>) : null  }<iframe  id="docpdf"  src={srcURL} 
                         height="500"
                         width="1000"
                         onLoad={() => setLoading(false)}
                         allowFullScreen={true}
                         
                         />
                 </div>
                </Box>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TableData;
